import { useSelector } from 'react-redux';
import { RootState } from '../../store';

export const checkPermissions = (code: string, actionTypes: string[], roles: any[], checkSubModule = false): boolean => {
  return roles.some((role: any) => {
    if (role.module && role.module.length > 0) {
      const foundModule = role.module.find((moduleItem: any) => {
        return moduleItem.code === code;
      });
      if (foundModule && foundModule.permissions) {
        if (actionTypes.some((actionType) => foundModule.permissions[actionType])) {
          return true;
        }
      }

      if (checkSubModule) {
        const hasSubModulePermission = role.module.some((moduleItem: any) => {
          const foundSubModule = moduleItem.subModules?.find((subModuleItem: any) => {
            return subModuleItem.code === code;
          });
          if (foundSubModule && foundSubModule.permissions) {
            return actionTypes.some((actionType) => foundSubModule.permissions[actionType]);
          }
          return false;
        });
        if (hasSubModulePermission) {
          return true;
        }
      }
    }
    return false;
  });
};

export const useCheckPermissions = (code: string, actionTypes: string[], checkSubModule = false): boolean => {
  const roles = useSelector((state: RootState) => state.roles.roles);
  return checkPermissions(code, actionTypes, roles, checkSubModule);
};
